<template>
    <div class="sub-assignments-nav" role="tablist">
        <b-card no-body
                class="sub-assignment-nav-item"
                v-for="subAssignment in assignmentIn.sub_assignments"
                :key="subAssignment.id"
                v-if="selectedSubAssignment">
            <b-card-header header-tag="header" role="tab" header-class="sub-assignment-nav-header">
                <b-button block href="#"
                          @click="selectSubAssignment(subAssignment)"
                          :aria-expanded="selectedSubAssignment.id === subAssignment.id ? 'true' : 'false'"
                          active-class="active"
                          class="btn-sub-assignment-nav-item"
                          :active="selectedSubAssignment.id === subAssignment.id"
                          :class="selectedSubAssignment.id === subAssignment.id ? 'btn-after-chevron-up' : 'btn-after-chevron-down'"
                          variant="primary">
                    <span class="btn status-icon" :class="getCurrentStatus(subAssignment)"></span>
                    <span class="title">{{subAssignment.name}}</span>
                </b-button>
            </b-card-header>

            <b-collapse :id="`sub-assignment-${subAssignment.id}`"
                        accordion="sub-assignment-nav-accordion"
                        :class="[{'collapse show d-block': selectedSubAssignment.id === subAssignment.id }]"
                        v-if="selectedViewIn === 2">

                    <b-list-group>
                        <b-list-group-item v-for="page in subAssignment.pages"
                                           button
                                           active-class="active"
                                           :class="[{'active': selectedPageIdIn === page.id}]"
                                           :key="page.id"
                                           @click="selectPage(page.id)"
                                           class="sub-assignment-nav-page-item-link">
                            <i class="fas fa-fw fa-circle sub-assignment-page-status"
                               :style="{color: subAssignment.statuses.length> 0 ? subAssignment.statuses[0].color :  '#07A1FF'}"></i>
                            <span v-if="page.name">{{ page.name }}</span>
                            <span v-else>Pagina {{ page.order }}</span>
                        </b-list-group-item>
                    </b-list-group>

            </b-collapse>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: "design-2021-assignment-show-nav-component",
        props: ['assignmentIn', 'selectedPageIdIn', 'selectedSubAssignmentIdIn', 'selectedViewIn'],
        data() {
            return {
                selectedPageId: null,
            }
        },
        computed: {
            selectedSubAssignment () {
                if (!this.assignmentIn.sub_assignments.length || !this.selectedSubAssignmentIdIn) {
                    return null;
                }

                for (const subAssignment of this.assignmentIn.sub_assignments) {
                    if (subAssignment.id === this.selectedSubAssignmentIdIn) {
                        return subAssignment;
                    }
                }
            }
        },
        methods: {
            selectSubAssignment(subAssignment) {
                this.$emit('selected-sub-assignment', subAssignment.id)
            },
            selectPage(id) {
                this.$emit('selected-page', id)
            },

            getCurrentStatus(subAssignment) {
                if(!subAssignment.hasStatus()) {
                    return 'btn-money-check-edit btn-primary-icon-only';
                }

                if (subAssignment.hasStatus() && subAssignment.getStatus().isInSubmittedState()) {
                    return 'btn-hourglass-start btn-warning-icon-only';
                }

                if (subAssignment.hasStatus() && subAssignment.getStatus().isInReopenedState()) {
                    return 'btn-redo btn-danger-icon-only';
                }

                if (subAssignment.hasStatus() && subAssignment.getStatus().isInClosedState()) {
                    return 'btn-checked btn-success-icon-only';
                }
            }
        }
    }

</script>

<style scoped lang="scss">
    .sub-assignment-nav-item {
        background-color: transparent;
        border: none;

        header.sub-assignment-nav-header {
            border: none;
            padding: 0;
            margin: 0;
            border-bottom: unset;

            .title {
                align-self: center;
                text-align: left;
            }

            .status-icon {
                font-size: $base-font-size;
                margin-right: map-get($grid-gutter-spacing, 'ten');
                padding: 0;
                width: 20px;

                &:before {
                    margin-right: 0;
                }
            }
        }

        .btn-sub-assignment-nav-item {
            padding: map-get($grid-gutter-spacing, 'fifteen') map-get($grid-gutter-spacing, 'ten');
            border-radius: 4px;
            color: $text-color;
            background-color: $white;
            justify-content: flex-start;
            border: none;
            outline: none;
            box-shadow: none;

            &:active,
            &:active:focus,
            &:focus {
                border: none;
                outline: none;
                box-shadow: none;
                color: $text-color;
                background-color: $white;
            }

            &.btn-after-sort-down:after {
                margin-bottom: 7px;
            }

            &.btn-after-sort-up:after {
                margin-top: 7px;
            }

            &:before,
            &:after {
                align-self: center;
                margin-left: auto;
                transition: all 3ms ease;
            }

            &:hover {
                color: $white;
                background-color: $info;
            }

            &.active {
                background-color: $white;
                color: $text-color;
                outline: none;

                &:hover {
                    color: $white;
                    background-color: $info;
                }
            }

            &:not(:disabled):not(.disabled).active:focus {
                box-shadow: none;
            }
        }

        .sub-assignment-nav-page-item-link {
            background-color: transparent;
            border: none;
            outline: none;
            box-shadow: none;
            color: $text-color;
            padding-bottom: map-get($grid-padding-spacing, 'ten');
            padding-left: 38px;

            .sub-assignment-page-status {
                font-size: 0.6875rem;
                margin-right: map-get($grid-gutter-spacing, 'eight');
            }

            &.active {
                font-weight: $font-weight-bold;
            }

            &:not(:last-child){
                border-bottom: 3px dotted $border-color;
            }

            &:hover {
                cursor: pointer;
                color: $primary;
            }
        }
    }


    .btn-money-check-edit {
        &:before {
            font-weight: 100;
        }
    }
</style>
